import { WorkModel } from '@Entities/work/work'
import React from 'react'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'

interface SongwriterWorkHeaderProps {
    work: WorkModel
}

const SongwriterWorkHeader = ({ work }: SongwriterWorkHeaderProps) => (
    <ViewWorkHeader work={work} backText="< Back to my catalog" />
)

export default SongwriterWorkHeader
